document.addEventListener('DOMContentLoaded', function () {

  // Cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const counts = document.querySelectorAll('.cart-count');
        counts.forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }
  updateCartCount();

  // Mobile menu toggle
  const toggle = document.querySelector('.mobile-menu-toggle');
  const nav = document.querySelector('.main-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function(e) {
      e.stopPropagation();
      nav.classList.toggle('open');
    });
  }

  // Mobile dropdown toggle - only on mobile
  document.querySelectorAll('.main-nav > ul > li').forEach(function(item) {
    var link = item.querySelector('a');
    var dropdown = item.querySelector('.dropdown');
    if (dropdown && link) {
      link.addEventListener('click', function(e) {
        if (window.innerWidth <= 640) {
          e.preventDefault();
          item.classList.toggle('open');
        }
      });
    }
  });

// Hover/touch to show second image on product cards
  document.querySelectorAll('.product-card').forEach(function(card) {
    var img = card.querySelector('.product-card-image img');
    if (!img) return;
    var primarySrc = img.src;
    var secondarySrc = card.getAttribute('data-second-image');
    if (!secondarySrc || secondarySrc.indexOf('no-image') > -1 || secondarySrc.indexOf('storefront/assets') > -1 || secondarySrc === primarySrc) return;

    var isMobile = window.matchMedia('(max-width: 768px)').matches;

    if (isMobile) {
      var tapped = false;
      card.addEventListener('touchend', function(e) {
        if (!tapped) {
          e.preventDefault();
          tapped = true;
          img.src = secondarySrc;
        } else {
          window.location = card.getAttribute('href');
        }
      });
    } else {
      card.addEventListener('mouseenter', function() {
        img.src = secondarySrc;
      });
      card.addEventListener('mouseleave', function() {
        img.src = primarySrc;
      });
    }
  });

});